// globals
$(function(){
  const nextToggle = 'next-slide-toggle';
  const nextTarget = 'next-slide-toggle-target';
  $('[data-js=' + nextToggle + ']').on('click',function(){
    $(this).toggleClass('is-active').next('[data-js=' + nextTarget + ']').toggleClass('is-active');
  })
})

$(function(){
  const nextToggle = 'hover-next-slide-toggle';
  const nextTarget = 'hover-next-slide-toggle-target';
  $('[data-js=' + nextToggle + ']').hover(function(){
    $(this).addClass('is-active').next('[data-js=' + nextTarget + ']').addClass('is-active');
  },function(){
    $(this).removeClass('is-active').next('[data-js=' + nextTarget + ']').removeClass('is-active');
  })
  $('[data-js=' + nextTarget + ']').hover(function(){
    $(this).addClass('is-active').prev('[data-js=' + nextToggle + ']').addClass('is-active');
  },function(){
    $(this).removeClass('is-active').prev('[data-js=' + nextToggle + ']').removeClass('is-active');
  })
})

$(function(){
  const inThisToggle = 'in-this-toggle';
  const inThisTarget = 'in-this-target';
  $('[data-js=' + inThisToggle + ']').on('click',function(){
    $(this).toggleClass('is-active').find('[data-js=' + inThisTarget + ']').slideToggle()
  })
})

$(function(){
  const toggle = 'toggle-';
  const target = 'target-';
  const thisClass = 'sp-hm';
  $('[data-js=' + toggle + thisClass + ']').on('click',function(){
    $(this).toggleClass('is-active');
    $('[data-js=' + target + thisClass +']').slideToggle()
  })
})

$(function(){
  // #で始まるa要素をクリックした場合に処理（"#"←ダブルクォーテンションで囲むのを忘れずに。忘れるとjQueryのバージョンによっては動かない。。）
  $('a[href^="#"]').click(function(){
    // 移動先を0px調整する。0を30にすると30px下にずらすことができる。
    var adjust = -100;
    // スクロールの速度（ミリ秒）
    var speed = 400;
    // アンカーの値取得 リンク先（href）を取得して、hrefという変数に代入
    var href= $(this).attr("href");
    // 移動先を取得 リンク先(href）のidがある要素を探して、targetに代入
    var target = $(href == "#" || href == "" ? 'html' : href);
    // 移動先を調整 idの要素の位置をoffset()で取得して、positionに代入
    var position = target.offset().top + adjust;
    // スムーススクロール linear（等速） or swing（変速）
    $('body,html').animate({scrollTop:position}, speed, 'swing');
    return false;
  });
});

  //送信ボタンを押した時のみバリデーションメッセージ表示
  $(function(){
    $(".p-cf7form").find('[type=submit]').click(function () {
      $(".p-cf7form").addClass("is-show");
    });
  })
  